import Antd from 'ant-design-vue';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import 'ant-design-vue/dist/reset.css'; // Ant Design Vue 4.x 的正确样式文件
// 引入 axios 并设置全局配置
//axios.defaults.baseURL = 'http://localhost:8081/'; // 根据你的后端API地址修改

const app = createApp(App)
app.use(router)
app.use(Antd)

app.mount('#app')